










































    import {Component, Vue, Watch} from "vue-property-decorator";
    import * as storeHelper from '@/store/store.helper';
    import {DocumentsModule, SectionsModule, DisplayModule, UsersModule} from '@/store/store.helper';
    import {NAVBAR_SIDE_ICON, NavBarInterface} from "@/store/types";
    import number from "vue-i18n/src/components/number";
    import { eventBus } from "@/main";
    import * as enums from "@/types/enums";
    @Component({})

export default class ChooseTopicsPage extends Vue {

    @DocumentsModule.DocumentsGetter private documentTopics;
    @DocumentsModule.DocumentsGetter private documentPageType;
    @DocumentsModule.DocumentsGetter private documentWelcome;
    @DocumentsModule.DocumentsGetter private documentTopicsTitle;
    @DocumentsModule.DocumentsGetter private documentSortBy;
    @DocumentsModule.DocumentsGetter private documentTitle;


      @SectionsModule.SectionsGetter allSections;
    @SectionsModule.SectionsGetter private sectionsByStatus;
    @SectionsModule.SectionsGetter private sectionByIdDocumentAndByStatus;
    @SectionsModule.SectionsGetter private sectionsByTopicsAndStatuses;

    @DisplayModule.DisplayMutation private setNavBar;
    @DisplayModule.DisplayGetter private getColor;

    @UsersModule.UsersAction private validateUserAccessToDocument;

    private checkedTopics: number[] = [];
    private pick: boolean = false;
    private enums = enums;

    @Watch('checkedTopics')
    onCheckedTopicsChanged(val: number) {
        // TODO temporary solution
        localStorage.checkedList = val;
    }
    @Watch('pick')
    onPickChanged() {
        this.selectAll();
    }


    /**
     * @return number
     */
    public getI(): number {
        return 1
    }

    /**
     * @return {}
     */
    public data(): any {
        return {
            i: this.getI()
        }
    }

    /**
     * @return void
     */
    public selectAll(): void {
        if (this.pick) {
            this.checkedTopics = this.documentTopics.slice();
        } else {
            this.checkedTopics = [];
        }
    }

    private navigateTo(to): void {
        this.$router.push({name: to})
    }

    /**
     * @return void
     */
    public welcomeUrl(): void {
        this.$router.push({name: 'welcome'})
    }

    /**
     * @return void
     */
    public selectedList(): void {
        this.$router.push({name: enums.ROUTE_NAME.vote, params: { index: '1'}});
    }

    /**
     * @return void
     */
    private async mounted() {
        const navBarPref: NavBarInterface = {
            title: this.documentTopicsTitle,
            icon: NAVBAR_SIDE_ICON.menu,
            color: this.getColor(enums.SECTION_STATUS.inTheVote),
        };
        this.setNavBar(navBarPref);
        this.pick = true;
    }

    private goToVote(topic): void {
        localStorage.setItem('checkedList', topic);
        this.$router.push({name: enums.ROUTE_NAME.vote, params: { index: '1'}});
    }

    private onClickBack() {
        history.go(-1);
    }

    // Used to validate access to the document. Called before the route rendered by this component is confirmed.
    public beforeRouteEnter (to, from, next) {
        next(async vm => {
            const authorized = await vm.validateUserAccessToDocument()
            authorized || next(from)
        });
    }
}
